import shopDetailOtherDish from './oherDish'
import shopDetailOtherEmail from './oherEmail'
import shopDetailOtherBankflow from './oherBankflow'
import shopDetailOtherExtra from './oherExtra'
import shopDetailOtherIntegator from './otherIntegator'
import baseDetail from './baseDetail'
import outputResult from './marketCalculator'

export default {
  shopDetailOtherDish,
  shopDetailOtherEmail,
  shopDetailOtherBankflow,
  shopDetailOtherExtra,
  shopDetailOtherIntegator, // 物流集成商
  baseDetail, // 基础信息
  outputResult, // 计算结果
}
